import angular from "angular";
import $ from 'jquery';
import * as XLSX from 'xlsx-js-style';
import '../../../lib/jquery-table-exporter/table2CSV.js';

// angular visibility evaluator for ng-show/ng-hide on .isOrs ---
const orsExpr = /^\s*(!)?([A-Za-z0-9_]+)\.isOrs\s*$/;

const directive = ($rootScope) => {
    return {
        restrict: 'AE',
        scope: {
            tableIdToExport: '@',
            fileName: "@",
            exclude: "@",
            buttonName: "@",
            disabled: "<?",
            filenameFn: "&?"
        },
        template: require('./export-table-to-template.html'),
        link: function ($scope) {

            const angularIsOrsTest = ($node) => {
                // Check the node and its ancestors
                let $cur = $node;
                while ($cur && $cur.length) {
                    const showAttr = $cur.attr('ng-show') || $cur.attr('data-ng-show');
                    if (showAttr && orsExpr.test(showAttr)) {
                        const neg = !!showAttr.match(orsExpr)[1];
                        const shouldShow = neg ? !$rootScope.isOrs : $rootScope.isOrs;
                        if (!shouldShow) {
                            // ng-show is false => hidden
                            return false;
                        }
                    }
                    const hideAttr = $cur.attr('ng-hide') || $cur.attr('data-ng-hide');
                    if (hideAttr && orsExpr.test(hideAttr)) {
                        const neg = !!hideAttr.match(orsExpr)[1];
                        const shouldHide = neg ? !$rootScope.isOrs : $rootScope.isOrs;
                        if (shouldHide) {
                            // ng-hide is true => hidden
                            return false;
                        }
                    }
                    $cur = $cur.parent();
                }
                return true;
            };

            function resolveFileName() {
                if ($scope.filenameFn) {
                    const result = $scope.filenameFn();
                    if (result) return result;
                }
                return $scope.fileName || 'file';
            }

            $scope.exportToExcel = function () {
                const tableEl = document.getElementById($scope.tableIdToExport);
                if (!tableEl) return;

                const excludeSelector = $scope.exclude ? $scope.exclude : '.noExport';
                const rows = collectVisibleRows(tableEl, excludeSelector, angularIsOrsTest);
                if (!rows.length) return;

                const aoa = rows.map(r => r.map(c => c.value));
                const ws = XLSX.utils.aoa_to_sheet(aoa);

                rows.forEach((row, r) => {
                    row.forEach((cell, c) => {
                        if (!cell.style && !cell.numberFormat) return;
                        const ref = XLSX.utils.encode_cell({ r, c });
                        const wsCell = ws[ref];
                        if (!wsCell) return;
                        if (cell.style) wsCell.s = cell.style;
                        if (cell.numberFormat) {
                            wsCell.z = cell.numberFormat;
                            wsCell.t = 's';
                        }
                    });
                });

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                XLSX.writeFile(wb, resolveFileName() + '.xlsx');
            };

            $scope.exportToCSV = function () {
                $('#' + $scope.tableIdToExport).table2CSV({
                    separator: ',',
                    exclude: $scope.exclude ? $scope.exclude : ".noExport",
                    delivery: 'download',
                    filename: resolveFileName(),
                    angularIsOrsTest
                });
            };
        }
    };
};

function collectVisibleRows(tableEl, excludeSelector, angularIsOrsTest) {
    const rows = [];
    tableEl.querySelectorAll('tr').forEach(tr => {
        const $tr = $(tr);
        if ($tr.is(excludeSelector)) return;
        if ($tr.hasClass('ng-hide') || $tr.css('display') === 'none') return;
        if (!angularIsOrsTest($tr)) return;

        const row = [];
        tr.querySelectorAll('td, th').forEach(cell => {
            const $cell = $(cell);
            if ($cell.is(excludeSelector)) return;
            if ($cell.hasClass('ng-hide') || $cell.css('display') === 'none') return;
            if (!angularIsOrsTest($cell)) return;

            row.push(extractCell($cell, angularIsOrsTest));
        });
        if (row.length) rows.push(row);
    });
    return rows;
}

function extractCell($cell, angularIsOrsTest) {
    const $clone = $('<div>').html($cell.html());
    $clone.find('*').each(function () {
        const $el = $(this);
        if (!angularIsOrsTest($el) || $el.hasClass('ng-hide')) {
            $el.remove();
        }
    });

    const text = $clone.text().replace(/\s+/g, ' ').trim();
    const styles = parseInlineStyles($cell.attr('style') || '');
    const numberFormat = parseMsoNumberFormat(styles['mso-number-format']);
    return {
        value: numberFormat === '@' ? text : coerceNumber(text),
        style: buildXlsxStyle(styles),
        numberFormat
    };
}

function parseInlineStyles(styleAttr) {
    const result = {};
    styleAttr.split(';').forEach(decl => {
        const colonIdx = decl.indexOf(':');
        if (colonIdx < 0) return;
        const key = decl.substring(0, colonIdx).trim().toLowerCase();
        const value = decl.substring(colonIdx + 1).trim();
        if (key) result[key] = value;
    });
    return result;
}

function parseMsoNumberFormat(value) {
    if (!value) return null;
    // mso-number-format: '\@' means treat as text
    if (/^['"]?\\?@['"]?$/.test(value.trim())) return '@';
    return null;
}

function buildXlsxStyle(styles) {
    const out = {};
    const bgHex = cssColorToHex(styles['background-color']);
    if (bgHex) out.fill = { patternType: 'solid', fgColor: { rgb: 'FF' + bgHex } };
    const fgHex = cssColorToHex(styles['color']);
    if (fgHex) out.font = { color: { rgb: 'FF' + fgHex } };
    return Object.keys(out).length ? out : null;
}

function cssColorToHex(cssColor) {
    if (!cssColor) return null;
    const value = cssColor.trim();
    const rgb = value.match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (rgb) {
        return [rgb[1], rgb[2], rgb[3]]
            .map(n => parseInt(n, 10).toString(16).padStart(2, '0').toUpperCase())
            .join('');
    }
    if (value.startsWith('#')) {
        const h = value.substring(1);
        if (h.length === 3) {
            return h.split('').map(c => c + c).join('').toUpperCase();
        }
        return h.toUpperCase();
    }
    return null;
}

function coerceNumber(text) {
    if (text === '' || text === null || text === undefined) return text;
    if (!/^-?\d+(\.\d+)?$/.test(text)) return text;
    // Keep as text if there's a leading zero before another digit (e.g. "0000", "00", "007").
    // Number-typing would drop those zeros and change the meaning of hex-like/id-like values.
    if (/^-?0\d/.test(text)) return text;
    // Keep as text if the integer portion exceeds JS's safe-integer precision
    // (parseFloat would silently round, e.g. "1234567890123456789" → 1234567890123456800).
    const digits = text.replace(/^-/, '').replace('.', '');
    if (digits.length > 15) return text;
    return parseFloat(text);
}

angular
    .module('ui-common')
    .directive("exportTableTo", ['$rootScope', directive]);
